module.exports = __webpack_public_path__ + "static/media/tree_6.054edc1f.jpg";